import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import baseApi from "../../api/baseApi";

import { Slide, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const initialState = {
  settings: {},
  settingsLoading: true,
  settingsRefresh: true,

  updateSettingLoading: false,
};

export const fetchSetting = createAsyncThunk(
  "setting/fetchSetting",
  async () => {
    try {
      const response = await baseApi.get(`/GlobalSetting`);

      toast.dismiss();

      return response.data.Value;
    } catch (error) {
      toast.error({
        render: "Hata: " + error.response.data.Error.Description,
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
      });

      throw new Error(
        error.response?.data?.Error?.Description || error.response?.status
      );
    }
  }
);

export const settingSlice = createSlice({
  name: "setting",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSetting.pending, (state, action) => {
        state.settings = {};
        state.settingsLoading = true;
      })
      .addCase(fetchSetting.fulfilled, (state, action) => {
        state.settings = action.payload;
        state.settingsLoading = false;
      })
      .addCase(fetchSetting.rejected, (state, action) => {
        state.settings = {};
        state.settingsLoading = false;
      });
  },
});

export default settingSlice.reducer;
